import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { Constants } from 'src/shared/utilities/constants.util';
import { CostCenterMappingService } from 'src/shared/services/cost-center-mapping.service';
import { CostCenterMapping } from 'src/shared/models/cost-center-mapping.model';
import { CostCenter } from 'src/shared/models/cost-center.model';
import { CostCenterService } from 'src/shared/services/cost-center.service';
import { WorkflowPageUtil } from 'src/app/workflow/base-classes/workflow-page/workflow-page.util';
import { MappingComponentBase } from 'src/shared/admin-page/mapping-page-base.component';

@Component({
  selector: 'smt-cost-center-mapping',
  templateUrl: './cost-center-mapping.component.html',
  styleUrls: ['./cost-center-mapping.component.scss']
})
export class CostCenterMappingComponent extends MappingComponentBase implements AfterViewInit {
    allCostCenters: CostCenter[];
    availableCostCenters: CostCenter[];
    sortOptions: string[] = [ "Client Cost Center", "Mapped Value", "Last Modified Date", "Last Modified By" ];

    constructor(
        public _costCenterMappingService: CostCenterMappingService,
        protected _changeDetector: ChangeDetectorRef,
        private _costCenterService: CostCenterService) { 
            super(_costCenterMappingService, _changeDetector)
    }
    async ngAfterViewInit() {
        let costCenterResult = await this._costCenterService.getCostCenters(false, 0, 0, '', 'Name', Constants.DirectionAscending, false);
        this.allCostCenters = costCenterResult;
        this.setAvailableCostCenters();
    }

    getDisplayName(mapping: CostCenterMapping): string {
        return mapping.clientCostCenterName;
    }

    setAvailableCostCenters() {        
        if (this.allCostCenters && this.mappingComponent.selection && this.mappingComponent.selection.source == 'Ancillary Patient UOS') {
            this.availableCostCenters = this.allCostCenters.filter(c => WorkflowPageUtil.hasUosConfiguration(c));
        } else {
            this.availableCostCenters = this.allCostCenters;
        }
    }

    getCostCenterName(costCenterId: number|null): string {
        let costCenterName = '';
        if (this.allCostCenters && costCenterId != null) {
            let costCenter = this.allCostCenters.find(c => c.id == costCenterId);
            costCenterName = costCenter.name;
        }
        return costCenterName;
    }
}
